import { autoserialize, autoserializeAs } from 'cerialize';

export enum OwnerType {
  Charity = 'Charity',
  Partner = 'Partner',
  Organization = 'Organization',
}

export class Owner implements IOwner {
  @autoserialize id?: string;
  @autoserializeAs('owner_type') ownerType?: OwnerType;
  @autoserialize name?: string;

  constructor(payload?: IOwner) {
    this.id = payload?.id;
    this.ownerType = payload?.ownerType;
    this.name = payload?.name;
  }
}

export interface IOwner {
  id?: string;
  ownerType?: OwnerType;
  name?: string;
}
